const apiURL = process.env.REACT_APP_API_URL;

async function fetchClient(token, modelId) {
  const apiUrl = `${apiURL}/admin/client/list`;

  try {
    const body = modelId ? { ModelId: modelId } : {};

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data.message.list;
  } catch (error) {
    console.error("Error fetching documents:", error);
    throw error;
  }
}

export default fetchClient;
